import React from 'react';

const ConfirmModal = ({ message, onConfirm, onCancel }) => {
  return (
    <div className="modal-overlay">
      <div className="modal">

        <p>{message}</p>
        <div className="buttons center">
          <button onClick={onCancel} className="modal-button cancel-button">Indietro</button>
          <button onClick={onConfirm} className="modal-button confirm-button">Procedi</button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
